module.exports = __webpack_public_path__ + "static/media/auth_3.png";